module.exports = {"title":"Flexpass Details","flexpassUse":"How many flexpass tickets do you want to use?","availableEvents":"Available events","cancel":"Cancel","confirm":"Confirm early payout","close":"Close","apply":"Apply"}


//////////////////
// WEBPACK FOOTER
// ./src/components/EventListing/FlexpassDetailsModal/locales/en.json
// module id = 1341
// module chunks = 0